export default {"src":"/_next/static/media/specsIcon.36a67f5d.svg","height":11,"width":25,"blurWidth":0,"blurHeight":0};